import React, { useContext } from 'react';
import Isvg from 'react-inlinesvg';
import ReactModal from 'react-modal';

import Button from 'components/Button';
import Message from 'components/Message';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';

import CookiesContext, { CONSENT_MODELS } from '../CookiesContext';

import { messages } from './CookieBanner.messages';

import './CookieBanner.scss';

const { block, element } = bem('cookie-banner');

function CookieBanner() {
  const { consentModel, showBanner, acceptAll, rejectAll, openModal, saveCurrentSelection } =
    useContext(CookiesContext);
  const usesGDPRRules = consentModel === CONSENT_MODELS.GDPR_RULES;
  const usesCCPARules = consentModel === CONSENT_MODELS.CCPA_RULES;

  const bodyMessage = usesGDPRRules ? messages.bodyEU : messages.body;

  return (
    <ReactModal
      isOpen={showBanner}
      shouldFocusAfterRender={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={process.env.NODE_ENV !== 'test'}
      overlayClassName={element('overlay')}
      className={block({ eu: usesGDPRRules, ca: usesCCPARules })}>
      <Isvg src={ICONS.cookie} className={element('icon')} />

      <h4 className={element('header')}>
        <Message message={messages.header} />
      </h4>

      <p className={element('body')}>
        <Message
          message={bodyMessage}
          values={{
            'privacy-policy-link': chunks => (
              <a href={LINKS.privacyPolicy.href} target="_blank" rel="noreferrer noopener" className={element('link')}>
                {chunks}
              </a>
            ),
          }}
        />
      </p>

      <section className={element('actions')}>
        <When predicate={usesGDPRRules}>
          <Button styled="primary" className={element('action', { primary: true })} onClick={acceptAll}>
            <Message message={messages.accept} />
          </Button>
          <Button styled="primary-outline" className={element('action', { secondary: true })} onClick={rejectAll}>
            <Message message={messages.reject} />
          </Button>
          <Button styled="link" className={element('action', { tertiary: true })} onClick={openModal}>
            <Message message={messages.cookieSettings} />
          </Button>
        </When>

        <When predicate={usesCCPARules}>
          <Button styled="primary" className={element('action', { primary: true })} onClick={acceptAll}>
            <Message message={messages.accept} />
          </Button>
          <Button styled="primary-outline" className={element('action', { secondary: true })} onClick={openModal}>
            <Message message={messages.cookiePreferences} />
          </Button>
        </When>

        <When predicate={!usesGDPRRules && !usesCCPARules}>
          <Button styled="primary" className={element('action', { primary: true })} onClick={acceptAll}>
            <Message message={messages.ok} />
          </Button>
          <Button styled="primary-outline" className={element('action', { secondary: true })} onClick={openModal}>
            <Message message={messages.cookiePreferences} />
          </Button>
        </When>
      </section>

      <When predicate={!usesCCPARules}>
        <Isvg src={ICONS.cross} className={element('close-icon')} onClick={() => saveCurrentSelection()} />
      </When>
    </ReactModal>
  );
}

export default CookieBanner;
